import pvhApi from '@/api/pvhApi'

import router from '@/router'
import usersApi
  from '@/api/usersApi'

const state = () => ({
  tableHeaders: {
    allActive: false
  },
  role: {
    name: '',
    worker: 1,
    lawyer: 0,
    admin: 0
  },
  workerTableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Должность',
        isSortable: false
      },
      {
        title: 'Имя',
        isSortable: false
      },
      {
        title: 'Фамилия',
        isSortable: false
      },
      {
        title: 'Отчество',
        isSortable: false
      },
      {
        title: 'Username',
        isSortable: false
      }
    ]
  },
  workers: [],
  workersSelectedTableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Должность',
        isSortable: false
      },
      {
        title: 'Имя',
        isSortable: false
      },
      {
        title: 'Фамилия',
        isSortable: false
      },
      {
        title: 'Отчество',
        isSortable: false
      },
      {
        title: 'Username',
        isSortable: false
      }
    ]
  },
  workersSelected: [],
  selectedWorkerIsActiveDelete: false,
  workerSelectedResponseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  workersModal: {
    active: false,
    updatedId: null,
    isLoading: false,
    name: '',
    validation: {
      name: {
        type: null,
        message: ''
      }
    }
  },
  workersPagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 20,
    currentPage: 1,
    lastPage: 0
  },

  statusesTableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Имя',
        isSortable: false
      },
      {
        title: 'Цвет',
        isSortable: false
      },
      {
        title: 'Ручной выбор',
        isSortable: false
      }
    ]
  },
  statuses: [],
  statusesSelectedTableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Имя',
        isSortable: false
      },
      {
        title: 'Цвет',
        isSortable: false
      },
      {
        title: 'Ручной выбор',
        isSortable: false
      }
    ]
  },
  statusesSelected: [],
  selectedStatusesIsActiveDelete: false,
  statusesSelectedResponseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  statusesModal: {
    active: false,
    updatedId: null,
    isLoading: true,
    name: '',
    validation: {
      name: {
        type: null,
        message: ''
      }
    }
  },
  statusesPagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 20,
    currentPage: 1,
    lastPage: 0
  },

  validation: {
    name: { type: null, message: '' }
  },
  searchValue: '',
  isLoading: true
})

const getters = {
  '[pvh] getRoleForUpdate': state => state.role,
  '[pvh] getRoleTableHeaders': state => state.tableHeaders,

  '[pvh] getRoleUpdateWorkersList': state => state.workers,
  '[pvh] getRoleWorkerTableHeaders': state => state.workerTableHeaders,
  '[pvh] getRoleWorkersSelectedTableHeaders': state => state.workersSelectedTableHeaders,
  '[pvh] getRoleUpdateWorkersSelected': state => state.workersSelected,
  '[pvh] getRoleWorkersSelectedIsActiveDelete': state => state.selectedWorkerIsActiveDelete,
  '[pvh] getRoleWorkerSelectedResponseModal': state => state.workerSelectedResponseModal,
  '[pvh] getRoleWorkersListModal': state => state.workersModal,
  '[pvh] getRoleUpdateWorkersPagination': state => state.workersPagination,

  '[pvh] getRoleUpdateStatusesList': state => state.statuses,
  '[pvh] getRoleStatusesTableHeaders': state => state.statusesTableHeaders,
  '[pvh] getRoleStatusesSelectedTableHeaders': state => state.statusesSelectedTableHeaders,
  '[pvh] getRoleUpdateStatusesSelected': state => state.statusesSelected,
  '[pvh] getRoleStatusesSelectedIsActiveDelete': state => state.selectedStatusesIsActiveDelete,
  '[pvh] getRoleStatusesSelectedResponseModal': state => state.statusesSelectedResponseModal,
  '[pvh] getRoleStatusesListModal': state => state.statusesModal,
  '[pvh] getRoleUpdateStatusesPagination': state => state.statusesPagination,

  '[pvh] getRoleUpdateValidation': state => state.validation,
  '[pvh] getRoleUpdateIsLoading': state => state.isLoading,
  '[pvh] getRoleUpdateUsersList': state => state.informTypeOptionList
}

const mutations = {
  '[pvh] GET_ROLE': (state, role) => {
    state.role = role
  },
  '[pvh] GET_ROLE_FOR_UPDATE': (state, role) => {
    state.role = {
      ...role
    }
    if (state.role.workers) {
      state.workersSelected = state.role.workers.map(worker => {
        return {
          id: worker.id,
          isActive: false,
          values: [
            worker.position ? worker.position.name : '',
            worker.profile.name ? worker.profile.name : '',
            worker.profile.surname ? worker.profile.surname : '',
            worker.profile.patronymic ? worker.profile.patronymic : '',
            worker.email ? worker.email : ''
          ]
        }
      }) 
    }
    console.log(role)
    if (state.role?.statuses) {
      state.statusesSelected = state.role.statuses.map(status => {
        return {
          id: status.id,
          isActive: false,
          values: [
            { data: status.name ? status.name : '', mod: '' },
            { data: status.color ? status.color : '', mod: 'colorCell' },
            { data: status.is_manual ? 'Да' : 'Нет', mod: '' }
          ]
        }
      })
    }
    state.isLoading = false
  },
  '[pvh] SET_ROLE_UPDATE_NAME': (state, value) => {
    state.role.name = value
  },
  '[pvh] SET_ROLE_UPDATE_WORKER': (state) => {
    state.role.is_worker = state.role.is_worker ? 0 : 1
  },
  '[pvh] SET_ROLE_UPDATE_LAWYER': (state) => {
    state.role.is_lawyer = state.role.is_lawyer ? 0 : 1
  },
  '[pvh] SET_ROLE_UPDATE_ADMIN': (state) => {
    state.role.is_admin = state.role.is_admin ? 0 : 1
  },
  '[pvh] SET_ROLE_UPDATE_INFORMER': (state, informer) => {
    state.role.informer = informer
  },

  '[pvh] SET_ROLE_ITEM_VALIDATION': (state, valid) => {
    if (valid?.name) {
      state.validation.name.message = valid.name[0]
      state.validation.name.type = 'error'
    }
    if (valid?.phone) {
      state.validation.phone.message = valid.phone[0]
      state.validation.phone.type = 'error'
    }
  },

  '[pvh] ROLE_UPDATE_CLEAR_VALIDATION': (state, inputName) => {
    // свитч кейсом очищать валидацию в нужном поле по имени инпута
    switch (inputName) {
      case 'name':
        state.validation.name = { type: null, message: '' }
        break
      default:
        break
    }
  },

  '[pvh] SET_ROLE_UPDATE_INITIAL_STATE': (state) => {
    state.role = {
      name: '',
      worker: 1,
      lawyer: 0,
      admin: 0
    }
  },

  '[pvh] SHOW_ROLE_WORKERS_LIST_MODAL': (state) => {
    state.workersModal.active = true
  },
  '[pvh] CLOSE_ROLE_WORKERS_LIST_MODAL': (state) => {
    state.workersModal.active = false
    state.workersModal.updatedId = null
    state.workerTableHeaders.allActive = false
    state.workers.forEach(e => {
      e.isActive = false
    })
  },
  '[pvh] GET_ROLE_WORKERS_LIST': (state, workersList) => {
    state.workers = workersList.map(worker => {
      return {
        ...worker,
        isActive: false,
        values: [
          worker.position ? worker.position.name : '',
          worker.profile.name ? worker.profile.name : '',
          worker.profile.surname ? worker.profile.surname : '',
          worker.profile.patronymic ? worker.profile.patronymic : '',
          worker.email ? worker.email : ''
        ]
      }
    })
    state.workersModal.isLoading = false
  },
  '[pvh] TOGGLE_ROLE_WORKER_LIST_ITEM_ACTIVE': (state, itemId) => {
    const itemsLength = state.workers.length
    let counter = 0

    state.workers.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    state.workerTableHeaders.allActive = counter === itemsLength
  },
  '[pvh] TOGGLE_ROLE_WORKER_LIST_ITEM_ACTIVE_ALL': (state) => {
    state.workerTableHeaders.allActive = !state.workerTableHeaders.allActive
    state.workerTableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.workers.forEach((elem) => {
      elem.isActive = state.workerTableHeaders.allActive
    })
  },
  '[pvh] ADD_ROLE_WORKER_SELECTED': (state) => {
    const selectedItemsSet = []
    state.workers.forEach((elem) => {
      if (elem.isActive) {
        if (!state.workersSelected.some(item => item.id === elem.id)) {
          selectedItemsSet.push({
            id: elem.id,
            values: [
              elem.position?.name,
              elem.profile.name ? elem.profile.name : '',
              elem.profile.surname ? elem.profile.surname : '',
              elem.profile.patronymic ? elem.profile.patronymic : '',
              elem.email ? elem.email : ''
            ]
          })
        }
      }
    })
    state.workersSelected.push(...selectedItemsSet)
  },
  '[pvh] TOGGLE_ROLE_SELECTED_WORKER_LIST_ITEM_ACTIVE': (state, itemId) => {
    const itemsLength = state.workersSelected.length
    let counter = 0

    state.workersSelected.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.selectedWorkerIsActiveDelete = true : state.selectedWorkerIsActiveDelete = false

    state.workersSelectedTableHeaders.allActive = counter === itemsLength
  },
  '[pvh] TOGGLE_ROLE_SELECTED_WORKER_LIST_ITEM_ACTIVE_ALL': (state) => {
    state.workersSelectedTableHeaders.allActive = !state.workersSelectedTableHeaders.allActive
    state.workersSelectedTableHeaders.allActive ? state.selectedWorkerIsActiveDelete = true : state.selectedWorkerIsActiveDelete = false

    state.workersSelected.forEach((elem) => {
      elem.isActive = state.workersSelectedTableHeaders.allActive
    })
  },
  '[pvh] RESET_ROLE_WORKER_SELECTED_ALL_CHECKS': (state) => {
    state.workersSelectedTableHeaders.allActive = false
    state.selectedWorkerIsActiveDelete = false
    state.workersSelected.forEach((elem) => {
      elem.isActive = state.workersSelectedTableHeaders.allActive
    })
  },
  '[pvh] DELETE_ROLE_WORKER_SELECTED_CHECKED_ITEMS_SUCCESS': (state) => {
    state.workerSelectedResponseModal.isActive = true
    state.workerSelectedResponseModal.title = 'Успех!'
    state.workerSelectedResponseModal.text = 'Вы успешно убрали пользователя(ей)'
    state.workerSelectedResponseModal.type = 'main'
  },
  '[pvh] CLOSE_DELETE_SELECTED_WORKER_RESPONSE_MODAL': (state) => {
    state.workerSelectedResponseModal.isActive = false
    state.workerSelectedResponseModal.title = ''
    state.workerSelectedResponseModal.text = ''
    state.workerSelectedResponseModal.type = ''
  },
  '[pvh] SET_ROLE_WORKERS_LIST_PAGINATION': (state, headers) => {
    state.workersPagination.currentPage = Number(
      headers['x-pagination-current-page']
    )
    state.workersPagination.lastPage = Number(headers['x-pagination-page-count'])
    state.workersPagination.pageList.pages = [
      ...Array(Number(headers['x-pagination-page-count'])).keys()
    ].map(i => ++i)
  },
  '[pvh] TOGGLE_ROLE_WORKERS_LIST_PAGE_LIST': state => {
    state.workersPagination.pageList.active = !state.workersPagination.pageList.active
  },
  '[pvh] CLOSE_ROLE_WORKERS_LIST_PAGE_LIST': state => {
    state.workersPagination.pageList.active = false
  },
  '[pvh] RESET_ROLE_WORKERS_LIST_CURRENT_PAGE': state => {
    state.workersPagination.currentPage = 1
  },

  '[pvh] SHOW_ROLE_STATUSES_LIST_MODAL': (state) => {
    state.statusesModal.active = true
  },
  '[pvh] CLOSE_ROLE_STATUSES_LIST_MODAL': (state) => {
    state.statusesModal.active = false
    state.statusesModal.updatedId = null
    state.statusesTableHeaders.allActive = false
    state.statuses.forEach(e => {
      e.isActive = false
    })
    state.statusesPagination.currentPage = 1
  },
  '[pvh] GET_ROLE_STATUSES_LIST': (state, statusesList) => {
    state.statuses = statusesList.map(status => {
      return {
        ...status,
        isActive: false,
        values: [
          { data: status.name ? status.name : '', mod: '' },
          { data: status.color ? status.color : '', mod: 'colorCell' },
          { data: status.is_manual ? 'Да' : 'Нет', mod: '' }
        ]
      }
    })
    state.statusesModal.isLoading = false
  },
  '[pvh] TOGGLE_ROLE_STATUSES_LIST_ITEM_ACTIVE': (state, itemId) => {
    const itemsLength = state.statuses.length
    let counter = 0
    state.statuses.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })
    state.statusesTableHeaders.allActive = counter === itemsLength
  },
  '[pvh] TOGGLE_ROLE_STATUSES_LIST_ITEM_ACTIVE_ALL': (state) => {
    state.statusesTableHeaders.allActive = !state.statusesTableHeaders.allActive
    state.statusesTableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false
    state.statuses.forEach((elem) => {
      elem.isActive = state.statusesTableHeaders.allActive
    })
  },
  '[pvh] ADD_ROLE_STATUSES_SELECTED': (state) => {
    const selectedItemsSet = []
    state.statuses.forEach((elem) => {
      if (elem.isActive) {
        if (!state.statusesSelected.some(item => item.id === elem.id)) {
          selectedItemsSet.push({
            id: elem.id,
            values: [
              { data: elem.name ? elem.name : '', mod: '' },
              { data: elem.color ? elem.color : '', mod: 'colorCell' },
              { data: elem.is_manual ? 'Да' : 'Нет', mod: '' }
            ]
          })
        }
      }
    })
    state.statusesSelected.push(...selectedItemsSet)
  },
  '[pvh] TOGGLE_ROLE_SELECTED_STATUSES_LIST_ITEM_ACTIVE': (state, itemId) => {
    const itemsLength = state.statusesSelected.length
    let counter = 0
    state.statusesSelected.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })
    counter > 0 ? state.selectedStatusesIsActiveDelete = true : state.selectedStatusesIsActiveDelete = false
    state.statusesSelectedTableHeaders.allActive = counter === itemsLength
  },
  '[pvh] TOGGLE_ROLE_SELECTED_STATUSES_LIST_ITEM_ACTIVE_ALL': (state) => {
    state.statusesSelectedTableHeaders.allActive = !state.statusesSelectedTableHeaders.allActive
    state.statusesSelectedTableHeaders.allActive ? state.selectedStatusesIsActiveDelete = true : state.selectedStatusesIsActiveDelete = false
    state.statusesSelected.forEach((elem) => {
      elem.isActive = state.statusesSelectedTableHeaders.allActive
    })
  },
  '[pvh] RESET_ROLE_STATUSES_SELECTED_ALL_CHECKS': (state) => {
    state.statusesSelectedTableHeaders.allActive = false
    state.selectedStatusesIsActiveDelete = false
    state.statusesSelected.forEach((elem) => {
      elem.isActive = state.statusesSelectedTableHeaders.allActive
    })
  },
  '[pvh] DELETE_ROLE_STATUSES_SELECTED_CHECKED_ITEMS_SUCCESS': (state) => {
    state.statusesSelectedResponseModal.isActive = true
    state.statusesSelectedResponseModal.title = 'Успех!'
    state.statusesSelectedResponseModal.text = 'Вы успешно убрали статус(ы)'
    state.statusesSelectedResponseModal.type = 'main'
  },
  '[pvh] CLOSE_DELETE_SELECTED_STATUSES_RESPONSE_MODAL': (state) => {
    state.statusesSelectedResponseModal.isActive = false
    state.statusesSelectedResponseModal.title = ''
    state.statusesSelectedResponseModal.text = ''
    state.statusesSelectedResponseModal.type = ''
  },
  '[pvh] SET_ROLE_STATUSES_LIST_PAGINATION': (state, headers) => {
    state.statusesPagination.currentPage = Number(headers['x-pagination-current-page'])
    state.statusesPagination.lastPage = Number(headers['x-pagination-page-count'])
    state.statusesPagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  '[pvh] SET_CURRENT_PAGE_WORKES': (state, pageNum) => {
    state.workersPagination.currentPage = pageNum
  },
  '[pvh] SET_CURRENT_PAGE': (state, pageNum) => {
    state.statusesPagination.currentPage = pageNum
  },
  '[pvh] RESET_ROLE_STATUSES_LIST_CURRENT_PAGE': state => {
    state.statusesPagination.currentPage = 1
  }
}

const actions = {
  '[pvh] getRoleUpdateInfo' ({ commit }, id) {
    const params = {
      expands: 'expand=workers,statuses',
      id
    }

    pvhApi.getRoleUpdateInfo(params).then(response => {
      commit('[pvh] GET_ROLE_FOR_UPDATE', response.data.data)
    }).catch(error => {
      console.log('ошибка получения клиента', error)
    })
  },
  '[pvh] roleUpdateSetName' ({ commit }, value) {
    commit('[pvh] SET_ROLE_UPDATE_NAME', value)
  },
  '[pvh] roleUpdateSetSurname' ({ commit }, value) {
    commit('[pvh] SET_ROLE_UPDATE_SURNAME', value)
  },
  '[pvh] roleUpdateSetPatronymic' ({ commit }, value) {
    commit('[pvh] SET_ROLE_UPDATE_PATRONYMIC', value)
  },
  '[pvh] roleUpdateSetWorker' ({ commit }, value) {
    commit('[pvh] SET_ROLE_UPDATE_WORKER', value)
  },
  '[pvh] roleUpdateSetLawyer' ({ commit }, value) {
    commit('[pvh] SET_ROLE_UPDATE_LAWYER', value)
  },
  '[pvh] roleUpdateSetAdmin' ({ commit }, value) {
    commit('[pvh] SET_ROLE_UPDATE_ADMIN', value)
  },

  '[pvh] toggleRoleWorkerListItemActive' ({ commit }, itemId) {
    commit('[pvh] TOGGLE_ROLE_WORKER_LIST_ITEM_ACTIVE', itemId)
  },
  '[pvh] toggleRoleWorkerListItemActiveAll' ({ commit }) {
    commit('[pvh] TOGGLE_ROLE_WORKER_LIST_ITEM_ACTIVE_ALL')
  },
  '[pvh] toggleRoleSelectedWorkerListItemActive' ({ commit }, itemId) {
    commit('[pvh] TOGGLE_ROLE_SELECTED_WORKER_LIST_ITEM_ACTIVE', itemId)
  },
  '[pvh] toggleRoleSelectedWorkerListItemActiveAll' ({ commit }) {
    commit('[pvh] TOGGLE_ROLE_SELECTED_WORKER_LIST_ITEM_ACTIVE_ALL')
  },
  '[pvh] deleteRoleWorkerSelectedCheckedItems' ({ commit, state }) {
    const newSelectedWorkers = []
    state.workersSelected.forEach((e) => {
      if (!e.isActive) {
        newSelectedWorkers.push(e)
      }
    })

    state.workersSelected = newSelectedWorkers
    commit('[pvh] RESET_ROLE_WORKER_SELECTED_ALL_CHECKS')
    commit('[pvh] DELETE_ROLE_WORKER_SELECTED_CHECKED_ITEMS_SUCCESS')
  },
  '[pvh] closeRoleWorkerSelectedDeleteModal' ({ commit }) {
    commit('[pvh] CLOSE_DELETE_SELECTED_WORKER_RESPONSE_MODAL')
  },
  '[pvh] getRoleWorkersList' ({ commit, state }) {
    const params = {
      searchFilter: state.searchValue ? `search[all]=${state.searchValue}` : '',
      take: state.workersPagination.currentTake,
      page: state.workersPagination.currentPage
    }
    usersApi.getAll(params).then(response => {
      commit('[pvh] GET_ROLE_WORKERS_LIST', response.data.data)
      commit('[pvh] SET_ROLE_WORKERS_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения юзеров', error)
    })
  },
  '[pvh] showRoleWorkersListModal' ({ commit }) {
    commit('[pvh] SHOW_ROLE_WORKERS_LIST_MODAL')
  },
  '[pvh] closeRoleWorkersListModal' ({ commit }) {
    commit('[pvh] CLOSE_ROLE_WORKERS_LIST_MODAL')
  },
  '[pvh] addRoleWorkersSelected' ({ commit }) {
    commit('[pvh] ADD_ROLE_WORKER_SELECTED')
    commit('[pvh] CLOSE_ROLE_WORKERS_LIST_MODAL')
  },
  '[pvh] getRoleWorkerListPage' ({ commit }, pageNum) {
    commit('[pvh] SET_CURRENT_PAGE_WORKERS', pageNum)
    this.dispatch('[pvh] getRoleWorkersList')
  },

  '[pvh] toggleRoleStatusesListItemActive' ({ commit }, itemId) {
    commit('[pvh] TOGGLE_ROLE_STATUSES_LIST_ITEM_ACTIVE', itemId)
  },
  '[pvh] toggleRoleStatusesListItemActiveAll' ({ commit }) {
    commit('[pvh] TOGGLE_ROLE_STATUSES_LIST_ITEM_ACTIVE_ALL')
  },
  '[pvh] toggleRoleSelectedStatusesListItemActive' ({ commit }, itemId) {
    commit('[pvh] TOGGLE_ROLE_SELECTED_STATUSES_LIST_ITEM_ACTIVE', itemId)
  },
  '[pvh] toggleRoleSelectedStatusesListItemActiveAll' ({ commit }) {
    commit('[pvh] TOGGLE_ROLE_SELECTED_STATUSES_LIST_ITEM_ACTIVE_ALL')
  },
  '[pvh] deleteRoleStatusesSelectedCheckedItems' ({ commit, state }) {
    const newSelectedStatuses = []
    state.statusesSelected.forEach((e) => {
      if (!e.isActive) {
        newSelectedStatuses.push(e)
      }
    })
    state.statusesSelected = newSelectedStatuses
    commit('[pvh] RESET_ROLE_STATUSES_SELECTED_ALL_CHECKS')
    commit('[pvh] DELETE_ROLE_STATUSES_SELECTED_CHECKED_ITEMS_SUCCESS')
  },
  '[pvh] closeRoleStatusesSelectedDeleteModal' ({ commit }) {
    commit('[pvh] CLOSE_DELETE_SELECTED_STATUSES_RESPONSE_MODAL')
  },
  '[pvh] getRoleStatusesList' ({ commit, state }) {
    const params = {
      searchFilter: state.searchValue ? `search[all]=${state.searchValue}` : '',
      take: state.statusesPagination.currentTake,
      page: state.statusesPagination.currentPage
    }
    pvhApi.getStatusList(params).then(response => {
      commit('[pvh] SET_ROLE_STATUSES_LIST_PAGINATION', response.headers)
      commit('[pvh] GET_ROLE_STATUSES_LIST', response.data.data)
    }).catch(error => {
      console.log('ошибка получения юзеров', error)
    })
  },
  '[pvh] showRoleStatusesListModal' ({ commit }) {
    commit('[pvh] SHOW_ROLE_STATUSES_LIST_MODAL')
  },
  '[pvh] closeRoleStatusesListModal' ({ commit }) {
    commit('[pvh] CLOSE_ROLE_STATUSES_LIST_MODAL')
  },
  '[pvh] addRoleStatusesSelected' ({ commit }) {
    commit('[pvh] ADD_ROLE_STATUSES_SELECTED')
    commit('[pvh] CLOSE_ROLE_STATUSES_LIST_MODAL')
  },
  '[pvh] getRoleStatusesListPage' ({ commit }, pageNum) {
    commit('[pvh] SET_CURRENT_PAGE', pageNum)
    this.dispatch('[pvh] getRoleStatusesList')
  },
  
  '[pvh] roleUpdateClearValidation' ({ commit }, inputName) {
    commit('[pvh] ROLE_UPDATE_CLEAR_VALIDATION', inputName)
  },
  '[pvh] roleUpdateSaveInfo' ({ commit, state }, id) {
    const roleData = {
      name: state.role.name,
      is_lawyer: state.role.is_lawyer,
      is_admin: state.role.is_admin,
      is_worker: state.role.is_worker,
      worker_ids: state.workersSelected.map((worker) => {
        return worker.id
      }),
      status_ids: state.statusesSelected.map((status) => {
        return status.id
      })
    }
    if (id === 'create') {
      pvhApi.postRoleUpdateSaveInfo(roleData).then(response => {
        router.push({ name: 'PvhRoleList' })
      }).catch(error => {
        commit('[pvh] SET_ROLE_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления клиента', error.response)
      })
    } else {
      pvhApi.putRoleUpdate(roleData, id).then(response => {
        router.push({ name: 'PvhRoleList' })
      }).catch(error => {
        commit('SET_ROLE_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления клиента', error.response)
      })
    }
  },
  '[pvh] setRoleUpdateInitialState' ({ commit, state }) {
    commit('[pvh] SET_ROLE_UPDATE_INITIAL_STATE', state)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
